import React from 'react';
import './Tag.scss';
import { ReactComponent as CheckIcon } from 'assets/icons/redesign/check-circle-fill.svg';
import { ReactComponent as PlayIcon } from 'assets/icons/redesign/play-fill.svg';
import { ReactComponent as LockIcon } from 'assets/icons/Lock.svg';
import { StageTone } from 'js/season';

const ICONS: Record<StageTone, React.FunctionComponent> = {
    done: CheckIcon,
    progress: PlayIcon,
    locked: LockIcon,
};
function Tag({
    label,
    tone,
}: {
    label: string;
    tone: StageTone;
}): React.ReactElement {
    const Icon = ICONS[tone];
    return (
        <span className={`rd-tag rd-tag--${tone}`}>
            <span className="rd-tag__icon">
                <Icon />
            </span>
            {label}
        </span>
    );
}

export default React.memo(Tag);
